// web 和 phone 操作相同的接口
import { ref, computed } from "vue";
import { useRouter, useRoute } from "vue-router";
import { useQAInfoStore } from "@/stores/QAInfo";
import { useLocale } from "@/composables/useI18n";
import { useAuthStore } from "@/stores/auth";
import eventBus from "@/utils/eventBus";
export const useHeader = () => {
  // 左侧icon操作
  const leftIcons = [
    { name: "comment-o", path: "/phone/qa" },
    { name: "records-o", path: "/phone/case-record-list" },
    { name: "orders-o", path: "/phone/order-list" },
  ];
  const router = useRouter();
  const { t, setLocale, locale } = useLocale();
  const qaInfoStore = useQAInfoStore();
  const authStore = useAuthStore();

  const route = useRoute();

  // Check if we're on the certificate view page
  const isCertificateView = computed(() => {
    return route.path === "/certificate/view";
  });

  const headTitle = computed(() => {
    // 根据路由判断标题
    if (route.fullPath.includes("/phone/qa") && route.fullPath !== "/phone/qa") {
      if (route.query.type === "locked") {
        return t("header.unlocked");
      } else {
        return t("header.history");
      }
    } else if (route.path === "/phone/case-record-list") {
      return t("header.allCases");
    } else if (route.path === "/phone/case-draft-list") {
      return t("header.allDrafts");
    } else {
      return t("header.newValuation");
    }
  });

  // Handle back navigation to case list
  const onBack = () => {
    router.push("/phone/case-record-list");
  };

  const onClick = (icon: any) => {
    if (icon.name === "comment-o") {
      // 清空数据
      qaInfoStore.clearAll();
      router.push("/phone/qa");
      eventBus.emit("resetQA");
    } else if (icon.name === "records-o") {
      router.push("/phone/case-record-list");
    } else if (icon.name === "orders-o") {
      router.push("/phone/case-draft-list");
    }
  };

  // 中英文切换
  const onSwitchLocale = () => {
    if (locale.value === "zh-CN") {
      setLocale("en-US");
    } else {
      setLocale("zh-CN");
    }
  };
  // 弹窗控制器
  const showPopover = ref(false);
  const actions = computed(() => {
    // Get language names
    const chineseName = t("header.languageChinese");
    const englishName = t("header.languageEnglish");

    const languageText =
      locale.value === "zh-CN" ? `${chineseName} ${englishName}` : `${englishName} ${chineseName}`;

    return [
      {
        text: t("header.balances"),
        icon: "balances",
      },
      {
        text: t("header.profile"),
        icon: "profile",
      },
      {
        text: languageText,
        icon: "language",
      },
      { text: t("header.logout"), icon: "logout" },
    ];
  });

  const onSelect = async (action: any) => {
    if (action.icon === "language") {
      onSwitchLocale();
    } else if (action.icon === "profile") {
      // Navigate to profile page or handle profile action
      router.push("/profile");
      console.log("Profile clicked");
    } else if (action.icon === "logout") {
      await authStore.logout();
      router.push("/login");
    } else {
      router.push("/balances");
    }
    showPopover.value = false;
  };
  return {
    leftIcons,
    showPopover,
    actions,
    headTitle,
    onSwitchLocale,
    onSelect,
    onClick,
    isCertificateView,
    onBack,
  };
};
